import(/* webpackMode: "eager" */ "/home/runner/_work/finn-auto-ui-frontend/finn-auto-ui-frontend/apps/finn-b2b-ui/app/error.tsx");
